<template>
  <div>
    <!-- Select existente -->
    <div class="mb-2">
      <label class="form-label">Selecciona categoría</label>
      <select
        class="form-select"
        :disabled="loading || options.length === 0"
        v-model="selectedName"
        @change="handleSelect"
        aria-label="Default select example"
      >
        <option value="" selected>Selecciona las categorías</option>
        <option v-for="opt in options" :key="opt" :value="opt">{{ opt }}</option>
      </select>
      <small v-if="loading" class="text-muted">Cargando categorías…</small>
      <small v-else-if="options.length === 0" class="text-muted">No hay categorías.</small>
      <small v-if="fetchError" class="text-danger d-block mt-1">{{ fetchError }}</small>
    </div>

    <!-- Agregar nueva si no existe -->
    <div class="input-group mb-2">
      <input
        v-model.trim="newCategory"
        type="text"
        class="form-control"
        placeholder="Agregar nueva categoría"
        @keyup.enter="addNew"
      />
      <button class="btn btn-dark" type="button" @click="addNew">Agregar</button>
    </div>
    <small class="text-muted">Si la categoría no existe, agrégala aquí y se sumará a la lista y a tu selección.</small>

    <!-- Seleccionadas -->
    <!-- <div v-if="localCategories.length" class="mt-3">
      <div class="form-text mb-1">Categorías seleccionadas:</div>
      <div class="d-flex flex-wrap gap-2">
        <span
          v-for="c in localCategories"
          :key="c.name.toLowerCase()"
          class="badge text-bg-secondary d-inline-flex align-items-center"
        >
          {{ c.name }}
          <button
            type="button"
            class="btn-close btn-close-white ms-2"
            aria-label="Eliminar"
            @click="removeCat(c.name)"
          ></button>
        </span>
      </div>
    </div> -->
  </div>
</template>

<script>
import Security from './security';

export default {
  name: 'CategoryPicker',
  props: {
    /* v-model:categories */
    categories: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:categories'],
  data() {
    return {
      loading: false,
      fetchError: '',
      options: [],        // lista de nombres (string)
      selectedName: '',   // v-model del <select>
      newCategory: '',    // input para nueva categoría
      localCategories: [],// espejo local de [{ name }]
    };
  },
  mounted() {
    // inicializa espejo local desde prop
    this.localCategories = Array.isArray(this.categories)
      ? [...this.categories]
      : [];

    // carga categorías
    this.fetchCategories();
  },
  watch: {
    // Si el padre cambia el v-model externamente, sincroniza
    categories: {
      handler(newVal) {
        this.localCategories = Array.isArray(newVal) ? [...newVal] : [];
      },
      deep: true,
    },
  },
  methods: {
    async fetchCategories() {
      this.loading = true;
      this.fetchError = '';
      try {
        const res = await fetch(
          process.env.VUE_APP_API_URL + '/api/product/categories/',
          Security.requestOptions({}, 'GET')
        );
        const data = await res.json();
        if (data.error) {
          this.fetchError = data.message || 'Error al cargar categorías.';
          this.options = [];
        } else {
          // Normaliza a lista de nombres (por si el API devuelve objetos)
          const names = Array.isArray(data)
            ? data.map((c) => (typeof c === 'string' ? c : c.name)).filter(Boolean)
            : [];
          // Unicos y ordenados
          this.options = [...new Set(names)].sort((a, b) => a.localeCompare(b));
        }
      } catch (e) {
        this.fetchError = 'No se pudieron obtener las categorías.';
        this.options = [];
      } finally {
        this.loading = false;
      }
    },

    norm(s) {
      return (s || '').toString().trim().toLowerCase();
    },

    alreadySelected(name) {
      const n = this.norm(name);
      return this.localCategories.some((c) => this.norm(c.name) === n);
    },

    ensureOptionExists(name) {
      // Si no está en options, lo agrega
      const n = this.norm(name);
      if (!this.options.some((o) => this.norm(o) === n)) {
        this.options.push(name);
        this.options.sort((a, b) => a.localeCompare(b));
      }
    },

    handleSelect() {
      const name = this.selectedName;
      if (!name) return;
      if (!this.alreadySelected(name)) {
        const updated = [...this.localCategories, { name }];
        this.localCategories = updated;
        this.$emit('update:categories', updated);
      }
      // Limpia el select a estado "placeholder"
      this.selectedName = '';
    },

    addNew() {
      const name = this.newCategory;
      if (!name) return;
      if (this.alreadySelected(name)) {
        this.newCategory = '';
        return;
      }
      // Asegura que aparezca en la lista de opciones
      this.ensureOptionExists(name);
      // Lo agrega también a la selección
      const updated = [...this.localCategories, { name }];
      this.localCategories = updated;
      this.$emit('update:categories', updated);
      this.newCategory = '';
    },

    removeCat(name) {
      const n = this.norm(name);
      const updated = this.localCategories.filter((c) => this.norm(c.name) !== n);
      this.localCategories = updated;
      this.$emit('update:categories', updated);
    },
  },
};
</script>
